import React from "react";
import Typography  from "@mui/material/Typography";
import Container   from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Phones,Tablets,Watch,Accessories } from "./ProductInfo.jsx"
import List from "./List.jsx";




function createlist(test) {
  return (
    <List
      name={test.name}
      img={test.img}
      desc={test.desc}
      price={test.price}

    />
  );
}




function Product() {
  
  return  <Container > 
  <Typography
  color="primary.light"
  variant="h1"
  component="h1">
    Products
  </Typography> 
  <Typography color="primary" variant="h2" component="h2">Phones</Typography> 
  <Grid container spacing={2}>
  {Phones.map(createlist)}
  </Grid>  
  <Typography color="primary" variant="h2" component="h2">Tablets</Typography> 
  <Grid container spacing={2}>
  {Tablets.map(createlist)}
  </Grid>
  <Typography color="primary" variant="h2" component="h2">Smart Watches</Typography> 
  <Grid container spacing={2}>
  {Watch.map(createlist)}
  </Grid>
    <Typography color="primary" variant="h2" component="h2">Accessories </Typography> 
  <Grid container spacing={2}>
  {Accessories.map(createlist)}
  </Grid> 
    
   
 





    </Container >;
}

export default Product;
